export enum AuthState {
    LOADING = 'loading',
    ERROR = 'error',
    SIGNED_IN = 'signed-in',
    SIGNED_OUT = 'signed-out',
}

export enum RouteType {
    AUTH = 'auth',
    PUBLIC = 'public',
    PRIVATE = 'private',
    RESTRICTED = 'restricted',
}
